import { PatientTypes } from '../enums';
export class PatientTypesLookup {
    getLookup() {
        let patientTypes = [];
        patientTypes.push({ label: 'In Patient', value: PatientTypes.inPatient });
        patientTypes.push({ label: 'Out Patient', value: PatientTypes.outPatient });
        patientTypes.push({ label: 'Both', value: PatientTypes.Both });
        return patientTypes
    };
}